import { render } from "./KeyModal.vue?vue&type=template&id=a801868e"
import script from "./KeyModal.vue?vue&type=script&lang=js"
export * from "./KeyModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__